module.exports = __webpack_public_path__ + "img/map-preview.f89ba2a4.jpg";